import { render, staticRenderFns } from "./SkupSuorganizatorDetails.vue?vue&type=template&id=8f63022c&scoped=true&"
import script from "./SkupSuorganizatorDetails.vue?vue&type=script&lang=js&"
export * from "./SkupSuorganizatorDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f63022c",
  null
  
)

export default component.exports